import {ErrorBoundary} from "react-error-boundary";
import {ProfileTemplateWidget} from "../../../components/widgets/template-widget";
import {DashboardWrapper} from "../../../layouts/dashboard-wrapper";
import {StyledPageHeader, StyledPageWrapper} from "../../../styles/dashboard/calls/calls";
import {Alert, Button} from "antd";
import {UserProfileFormPage} from "../../../profile/use-cases/edit-profile/page";

const EditProfilePage = () => {
  return (
    <DashboardWrapper pageTitle="Profile">
      {/* <StyledPageHeader>Profile 🧑</StyledPageHeader> */}
      <StyledPageHeader>Profile</StyledPageHeader>
      <StyledPageWrapper>
        <div className="main-area">
          <ErrorBoundary
            FallbackComponent={({error, resetErrorBoundary}) => (
              <div style={{marginTop: "1.8rem"}}>
                <Alert
                  message="Sorry, something went wrong."
                  showIcon
                  description={error.message}
                  type="error"
                  action={
                    <Button
                      onClick={() => {
                        resetErrorBoundary();
                      }}
                      size="small"
                      danger
                    >
                      Reset
                    </Button>
                  }
                />
              </div>
            )}
          >
            <UserProfileFormPage />
          </ErrorBoundary>
        </div>
        <div className="widget-area">
          {/* <ProfileWidget /> */}
          <ProfileTemplateWidget />
        </div>
      </StyledPageWrapper>
    </DashboardWrapper>
  );
};

export {EditProfilePage};
